import { useMemo } from 'react'
import Image from 'next/image'

import { Carousel, CarouselItem } from '@/components'

import { SellPoint3Type } from '../types'

const SellPoint3 = ({ blockData: data }: { blockData: string }) => {
  const blockData = useMemo(() => {
    if (data) {
      return JSON.parse(data) as SellPoint3Type
    }
  }, [data])

  return (
    <div>
      {/* pc端 */}
      <div className="pb-14 max-xl:hidden">
        <div className="px-3">
          <div className="mx-auto max-w-[1440px]">
            <h2
              className="!mb-4 !mt-0 font-miSansSemiBold520 !text-pc-h2 !font-medium text-black"
              dangerouslySetInnerHTML={{ __html: blockData?.title ?? '' }}></h2>
          </div>
        </div>
        <div className="mt-11">
          <Carousel
            indicatorsAction="click"
            autoPlay={false}
            options={{ align: 'center' }}
            indicatorsContainerClassName="left-[max(calc((100%-1440px)/2),12px)] translate-x-0 bottom-[-34px]"
            indicatorsItemClassName="bg-[#00000026]"
            indicatorsActiveItemClassName="bg-[#000000D9]"
            arrowIconSize={16}
            arrowLeftContainerClassName="w-9 h-9 top-[unset] right-[max(calc((100%-1440px)/2+48px),60px)] left-[unset] transform-[unset] bottom-[-64px] !opacity-100 bg-[#00000066]"
            arrowRightContainerClassName="w-9 h-9 top-[unset] right-[max(calc((100%-1440px)/2),12px)] transform-[unset] bottom-[-64px] !opacity-100 bg-[#00000066]"
            arrowHoverOption={{
              btnClassName: 'bg-[#0000004D]',
              iconColor: '#fff',
            }}
            arrowIconDisableClassName="bg-[#00000026]">
            {blockData?.features?.map((item, index) => (
              <CarouselItem
                key={index}
                className={`ml-9 flex w-full max-w-[1440px] justify-between gap-[9%] rounded-xl bg-gray-1 p-8 ${index === 0 ? 'ml-[max(calc((100%-1440px)/2),12px)]' : ''} last:mr-[max(calc((100%-1440px)/2),12px)]`}>
                <div>
                  <div
                    className="font-miSansDemiBold450 text-[32px] leading-[1.2] text-black"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <div className="mt-4 text-pc-lg text-gray-5">
                    {item.description.map((desc, index) => (
                      <p
                        key={index}
                        className="!mb-4 font-miSansMedium380 !text-pc-lg !leading-normal text-gray-5"
                        dangerouslySetInnerHTML={{ __html: desc }}></p>
                    ))}
                  </div>
                </div>
                <Image
                  src={item.pc_image}
                  width={826}
                  height={428}
                  alt={item.title}
                  className={`w-[59.7%] max-w-[826px] flex-shrink-0 rounded-xl bg-gray-4`}
                />
              </CarouselItem>
            ))}
          </Carousel>
        </div>
      </div>
      {/* mb端 */}
      <div className="pb-11 xl:hidden">
        <div className="px-3">
          <h2
            className="!mb-[6px] !mt-0 font-miSansDemiBold450 !text-[18px]"
            dangerouslySetInnerHTML={{ __html: blockData?.title ?? '' }}></h2>
        </div>
        <div className="mt-6">
          <Carousel
            indicatorsAction="click"
            options={{ align: 'center' }}
            autoPlay={false}
            indicatorsContainerClassName="bottom-[-24px] gap-[6px]"
            indicatorsItemClassName="bg-[#00000066] w-[6px] h-[6px]"
            indicatorsActiveItemClassName="bg-[#000000D9] w-[28px] h-[6px]"
            showArrows={false}>
            {blockData?.features?.map((item, index) => (
              <CarouselItem
                key={index}
                className={`ml-3 flex w-[320px] max-w-[320px] flex-col gap-3 rounded-lg bg-gray-1 p-4 ${index === 0 ? 'ml-3' : ''} last:mr-3`}>
                <Image
                  src={item.pc_image}
                  width={288}
                  height={151}
                  alt={item.title}
                  className={`w-full flex-shrink-0 rounded-md`}
                />
                <div>
                  <div
                    className="font-miSansDemiBold450 text-lg leading-[21px] text-black"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <div className="mt-2 text-sm text-gray-5">
                    {item.description.map((desc, index) => (
                      <p
                        key={index}
                        className="mb-4 font-miSansRegular330 !text-sm !leading-[16px] text-gray-5"
                        dangerouslySetInnerHTML={{ __html: desc }}></p>
                    ))}
                  </div>
                </div>
              </CarouselItem>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default SellPoint3
